import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  fetchFavouriteAccountAction,
  updateFavouriteAccountAction
} from "actions/user-settings-actions";
import { Loading } from "components/common/loading";
import { FavouriteAccount } from "components/settings/favourite-account";

class FavouriteAccountPage extends React.Component {
  componentWillMount() {
    this.props.init();
  }
  render() {
    if (this.props.isLoading) {
      return <Loading />;
    }
    return (
      <FavouriteAccount { ...this.props } />
    );
  }
}

FavouriteAccountPage.propTypes = {
  init: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  accounts: state.app.accounts,
  favouriteAccountId: state.userSettings.favouriteAccountId,
  isLoading: state.userSettings.isFavouriteAccountLoading
});

const mapDispatchToProps = (dispatch) => ({
  init: () => dispatch(fetchFavouriteAccountAction()),
  onUpdateFavouriteAccount: () => dispatch(updateFavouriteAccountAction())
});

export const FavouriteAccountContainer = connect(mapStateToProps, mapDispatchToProps)(FavouriteAccountPage);



// WEBPACK FOOTER //
// ./src/js/containers/settings/favourite-account-container.jsx